import React from 'react'

function Industries() {
	return (
		<>
			<section className="work-category pad-tb">
				<div className="container">
					<div className="row justify-content-center">
						<div className="col-lg-8">
							<div className="common-heading ptag">
								<span>We Have Worked Across Multiple Industries</span>
								<h2>Industries We Serve</h2>
								<p>Following are some of the industries to which we are succesfully serving our services from years.</p>
							</div>
						</div>
					</div>
					<div className="row mt30">
						<div className="col-lg-3 col-sm-6 col-6 wow fadeIn" data-wow-delay="1.9s">
							<div className="industry-workfor hoshd"><img src="images/icons/baker.svg" alt="img" />
								<h6>Government </h6>
							</div>
						</div>
						
						<div className="col-lg-3 col-sm-6 col-6 wow fadeIn" data-wow-delay="0.3s">
							<div className="industry-workfor hoshd"><img src="images/icons/travel-case.svg" alt="img" />
								<h6>Tour &amp; Travels</h6>
							</div>
						</div>
						<div className="col-lg-3 col-sm-6 col-6 wow fadeIn" data-wow-delay="0.5s">
							<div className="industry-workfor hoshd"><img src="images/icons/video-tutorials.svg" alt="img" />
								<h6>Education</h6>
							</div>
						</div>
						<div className="col-lg-3 col-sm-6 col-6 wow fadeIn" data-wow-delay="0.7s">
							<div className="industry-workfor hoshd"><img src="images/icons/taxi.svg" alt="img" />
								<h6>Transport</h6>
							</div>
						</div>
						<div className="col-lg-3 col-sm-6 col-6 wow fadeIn" data-wow-delay="0.9s">
							<div className="industry-workfor hoshd"><img src="images/icons/event.svg" alt="img" />
								<h6>Event</h6>
							</div>
						</div>
						<div className="col-lg-3 col-sm-6 col-6 wow fadeIn" data-wow-delay="1.1s">
							<div className="industry-workfor hoshd"><img src="images/icons/smartphone.svg" alt="img" />
								<h6>E-Commerce</h6>
							</div>
						</div>
						<div className="col-lg-3 col-sm-6 col-6 wow fadeIn" data-wow-delay="1.3s">
							<div className="industry-workfor hoshd"><img src="images/icons/joystick.svg" alt="img" />
								<h6>Game</h6>
							</div>
						</div>
						<div className="col-lg-3 col-sm-6 col-6 wow fadeIn" data-wow-delay="1.5s">
							<div className="industry-workfor hoshd"><img src="images/icons/healthcare.svg" alt="img" />
								<h6>Healthcare</h6>
							</div>
						</div>
						<div className="col-lg-3 col-sm-6 col-6 wow fadeIn" data-wow-delay="1.7s">
							<div className="industry-workfor hoshd"><img src="images/icons/money-growth.svg" alt="img" />
								<h6>Finance</h6>
							</div>
						</div>
						<div className="col-lg-3 col-sm-6 col-6 wow fadeIn" data-wow-delay="0.1s">
							<div className="industry-workfor hoshd"><img src="images/icons/house.svg" alt="img" />
								<h6>Real estate</h6>
							</div>
						</div>
						<div className="col-lg-3 col-sm-6 col-6 wow fadeIn" data-wow-delay="2.1s">
							<div className="industry-workfor hoshd"><img src="images/icons/mobile-app.svg" alt="img" />
								<h6>On-Demand</h6>
							</div>
						</div>
						<div className="col-lg-3 col-sm-6 col-6 wow fadeIn" data-wow-delay="2.3s">
							<div className="industry-workfor hoshd"><img src="images/icons/groceries.svg" alt="img" />
								<h6>Grocery</h6>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}

export default Industries